import * as constants from "./constants";
import { getLSKey, LS_KEYS } from "../../../utils/localStorageHelper";

const initialState = {
  allUsers: [],
  currentUserObj: {
    permissions: {
      ims: { add_edit: false, view: false, export: false, delete: false },
      labs_setup: {
        add_edit: false,
        view: false,
        export: false,
        delete: false,
      },
      user_manager: { add_edit: false, view: false, delete: false },
      departments: { add_edit: false, view: false, delete: false },
      variance_statuses: { add_edit: false, view: false, delete: false },
      lab_statuses: { add_edit: false, view: false, delete: false },
    },
    popupNotifications: false,
    emailNotifications: false,
  },
  user_labs: [],
  createLabLoading: false,
  currentLabObj: {},
  LabDetailsIsEdit: false,
  fetchLabsLoading: false,
  deleteLabLoading: false,
  utilsData: {},
  departmentsList: [],
  createUserLoading: false,
  userDetailsIsEdit: false,
  userPermissionsIsEdit: false,
  departmentIsEdit: false,
  fetchUsersLoading: false,
  deleteUserLoading: false,
  departmentLoading: false,
  settingsLoading: false,
  sendDetailLoading: false,
  fetchUserDetailLoading: false,
  settingsUpdatingKey: {
    popupNotifications: false,
    emailNotifications: false,
  },
  departItemsIndex: null,
  totalRecords: 0,
  popupLoading: false,
  emailLoading: false,
  permissionsLoading: false,
  isEditLabPermissions: false,
};

const userManagerReducer = (state = initialState, action) => {
  console.log("action", action);
  switch (action.type) {
    case constants.SET_DEPART_DISABLE_INDEX:
      return {
        ...state,
        departItemsIndex: action.data,
      };
    case constants.FETCH_USERS_UTIL_DATA_SUCCESS:
      const { sales_reps } = action.data;
      const sortedSalesrep = sales_reps.sort((a, b) => a.staffid - b.staffid);
      return {
        ...state,
        utilsData: {
          ...action.data,
          sales_reps: [
            { staffid: " ", listname: "Unselect" },
            ...sortedSalesrep,
          ],
        },
      };
    case constants.SET_USER_LAB_PERMISSIONS_IS_EDIT:
      return {
        ...state,
        isEditLabPermissions: action.data,
      };
    case constants.USER_DETAILS_IS_EDIT:
      return {
        ...state,
        userDetailsIsEdit: action.data,
      };
    case constants.SET_USER_PERMISSIONS_IS_EDIT:
      return {
        ...state,
        userPermissionsIsEdit: action.data,
      };
    case constants.CREATE_USER:
      return {
        ...state,
        createUserLoading: true,
      };
    case constants.CREATE_USER_SUCCESS:
      return {
        ...state,
        createUserLoading: false,
        currentUserObj: action.data,
        userDetailsIsEdit: false,
        departmentIsEdit: true,
      };
    case constants.CREATE_USER_ERROR:
      return {
        ...state,
        createUserLoading: false,
      };
    case constants.UPDATE_USER:
      return {
        ...state,
        createUserLoading: true,
      };
    case constants.UPDATE_USER_SUCCESS:
      return {
        ...state,
        createUserLoading: false,
        currentUserObj: action.data,
        userDetailsIsEdit: false,
      };
    case constants.UPDATE_USER_ERROR:
      return {
        ...state,
        createUserLoading: false,
      };
    case constants.UPDATE_USER_PERMISSIONS:
      return {
        ...state,
        permissionsLoading: true,
      };
    case constants.UPDATE_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissionsLoading: false,
        currentUserObj: action.data,
        userPermissionsIsEdit: false,
      };
    case constants.UPDATE_USER_PERMISSIONS_ERROR:
      return {
        ...state,
        permissionsLoading: false,
      };
    case constants.ADD_USER_IN_MANAGER:
      return {
        ...state,
        createUserLoading: true,
      };
    case constants.FETCH_ALL_USERS:
      return {
        ...state,
        fetchUsersLoading: true,
      };
    case constants.FETCH_ALL_USERS_SUCCESS:
      // API returns 'total' instead of 'total_users'
      const { total, users } = action.data;
      return {
        ...state,
        allUsers: users,
        fetchUsersLoading: false,
        totalRecords: total,
      };
    case constants.FETCH_ALL_USERS_ERROR:
      return {
        ...state,
        fetchUsersLoading: false,
      };
    case constants.DELETE_USER:
      return {
        ...state,
        deleteUserLoading: true,
      };
    case constants.DELETE_USER_SUCCESS:
      let updatedUsers = state.allUsers.filter(
        (el) => el.id !== action.data.id
      );
      let totalRecords = state.totalRecords - 1;
      return {
        ...state,
        totalRecords: totalRecords,
        deleteUserLoading: false,
        allUsers: updatedUsers,
      };
    case constants.DELETE_USER_ERROR:
      return {
        ...state,
        deleteUserLoading: false,
      };
    case constants.SAVE_DEPARTMENT:
      return {
        ...state,
        departmentLoading: true,
        departmentIsEdit: true,
      };
    case constants.SAVE_DEPARTMENT_SUCCESS:
      // let updatedUsers = state.allUsers.filter(
      //   (el) => el.id !== action.data.id
      // );
      const { departments } = action.data;
      return {
        ...state,
        departmentLoading: false,
        departmentIsEdit: false,
        currentUserObj: {
          ...state.currentUserObj,
          departments,
          departments_with_steps: departments,
        },
        // allUsers: updatedUsers,
      };
    case constants.SAVE_DEPARTMENT_ERROR:
      return {
        ...state,
        departmentLoading: false,
        departmentIsEdit: false,
      };
    case constants.CREATE_USER_LAB:
      return {
        ...state,
        createLabLoading: true,
      };
    case constants.CREATE_USER_LAB_SUCCESS:
      const newData = [action.data, ...state.user_labs];
      return {
        ...state,
        createLabLoading: false,
        user_labs: newData,
        LabDetailsIsEdit: false,
        LabIsEdit: false,
        isEditLabPermissions: false,
      };
    case constants.CREATE_USER_LAB_ERROR:
      return {
        ...state,
        createLabLoading: false,
      };

    case constants.DELETE_USER_LAB:
      return {
        ...state,
        createLabLoading: true,
      };
    case constants.DELETE_USER_LAB_SUCCESS:
      const { shouldLSUpdate } = action.data;
      // console.log("reducer shouldLSUpdate", shouldLSUpdate);
      // let user = JSON.parse(localStorage.getItem("user"));
      const filteredLabs = state.user_labs.filter(
        (el) => el.id !== action.data.id
      );
      // console.log("filteredLabs", filteredLabs);
      const userId = action.data.user_id; // Try to get userId if available
      let lselectedLabs = JSON.parse(
        localStorage.getItem(getLSKey(LS_KEYS.SELECTED_LABS, userId))
      );

      let lfilteredLabs = JSON.parse(
        localStorage.getItem(getLSKey(LS_KEYS.FILTERED_LABS, userId))
      );

      let lisCheck = JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.IS_CHECK, userId)));
      let llist = JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.LIST, userId)));
      if (
        filteredLabs.length >= 0 &&
        lselectedLabs !== null &&
        shouldLSUpdate
      ) {
        if (filteredLabs.length === 0) {
          console.log("filteredLabs.length", filteredLabs);
          localStorage.removeItem(getLSKey(LS_KEYS.SELECTED_LABS, userId));
          localStorage.removeItem(getLSKey(LS_KEYS.FILTERED_LABS, userId));
          localStorage.removeItem(getLSKey(LS_KEYS.IS_CHECK, userId));
          localStorage.removeItem(getLSKey(LS_KEYS.LIST, userId));
        } else {
          // if (filteredLabs[0].user_id !== user.id) {
          let userPojectsIds = filteredLabs.map((el) => el.lab_id);
          let updatedlsselectedLabs = lselectedLabs.filter((el) =>
            userPojectsIds.includes(el.id)
          );
          let updatedLsfilteredLabs = lfilteredLabs.filter((el) =>
            userPojectsIds.includes(el.id)
          );

          let updatedlsisCheck = lisCheck.filter((id) =>
            userPojectsIds.includes(id)
          );
          let updatedlslist = llist.filter((el) =>
            userPojectsIds.includes(el.id)
          );

          // const setToLocalStorage = (selectedLabs) => {
          localStorage.setItem(
            getLSKey(LS_KEYS.SELECTED_LABS, userId),
            JSON.stringify(updatedlsselectedLabs)
          );
          localStorage.setItem(
            getLSKey(LS_KEYS.FILTERED_LABS, userId),
            JSON.stringify(updatedLsfilteredLabs)
          );

          localStorage.setItem(getLSKey(LS_KEYS.IS_CHECK, userId), JSON.stringify(updatedlsisCheck));
          localStorage.setItem(getLSKey(LS_KEYS.LIST, userId), JSON.stringify(updatedlslist));
          // };
          // }
        }
      }
      return {
        ...state,
        createLabLoading: false,
        user_labs: filteredLabs,
        LabDetailsIsEdit: false,
        LabIsEdit: false,
        isEditLabPermissions: false,
      };
    case constants.DELETE_USER_LAB_ERROR:
      return {
        ...state,
        createLabLoading: false,
        isEditLabPermissions: false,
      };
    case constants.UPDATE_USER_LAB:
      return {
        ...state,
        createLabLoading: true,
      };
    case constants.UPDATE_USER_LAB_SUCCESS:
      const updatedUserLabs = state.user_labs.map((el) => {
        if (el.id === action.data.id) {
          return {
            ...el,
            ...action.data,
            labSetup: el.labSetup ? { ...el.labSetup, ...action.data.labSetup } : action.data.labSetup,
            lab: el.lab ? { ...el.lab, ...action.data.lab } : action.data.lab,
          };
        }
        return el;
      });

      return {
        ...state,
        createLabLoading: false,
        user_labs: updatedUserLabs,
        isEditLabPermissions: false,
      };
    case constants.UPDATE_USER_LAB_ERROR:
      return {
        ...state,
        createLabLoading: false,
      };
    case constants.FETCH_ALL_USER_LABS:
      return {
        ...state,
        fetchUserDetailLoading: true,
      };

    case constants.FETCH_ALL_USER_LABS_SUCCESS: {
      let { labs, user_id, total, page, perPage } = action.data;
      
      // Handle localStorage operations if labs exist
      let lsselectedLabs = JSON.parse(
        localStorage.getItem(getLSKey(LS_KEYS.SELECTED_LABS, user_id))
      ) || [];

      let lsfilteredLabs = JSON.parse(
        localStorage.getItem(getLSKey(LS_KEYS.FILTERED_LABS, user_id))
      ) || [];

      let lsisCheck = JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.IS_CHECK, user_id)) || '[]');
      let lslist = JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.LIST, user_id)) || '[]');
      
      // Only process localStorage if we have labs and lsselectedLabs exists
      if (Array.isArray(labs) && labs.length > 0 && lsselectedLabs !== null) {
        if (user_id && labs[0]?.user_id === user_id) {
          const userPojectsIds = labs.map((el) => el.lab_id);
          
          const updatedlsselectedLabs = lsselectedLabs.filter((el) =>
            userPojectsIds.includes(el.id)
          );
          
          const updatedLsfilteredLabs = lsfilteredLabs.filter((el) =>
            userPojectsIds.includes(el.id)
          );
          
          const updatedlsisCheck = lsisCheck.filter((id) =>
            userPojectsIds.includes(id)
          );
          
          const updatedlslist = lslist.filter((el) =>
            userPojectsIds.includes(el.id)
          );

          // Update localStorage with filtered data
          try {
            localStorage.setItem(
              getLSKey(LS_KEYS.SELECTED_LABS, user_id),
              JSON.stringify(updatedlsselectedLabs)
            );
            localStorage.setItem(
              getLSKey(LS_KEYS.FILTERED_LABS, user_id),
              JSON.stringify(updatedLsfilteredLabs)
            );
            localStorage.setItem(getLSKey(LS_KEYS.IS_CHECK, user_id), JSON.stringify(updatedlsisCheck));
            localStorage.setItem(getLSKey(LS_KEYS.LIST, user_id), JSON.stringify(updatedlslist));
          } catch (error) {
            console.error("Error updating localStorage:", error);
          }
        }
      }

      return {
        ...state,
        fetchUserDetailLoading: false,
        user_labs: Array.isArray(labs) ? labs : [],
        totalRecords: typeof total === 'number' ? total : 0,
        page: typeof page === 'number' ? page : 1,
        perPage: typeof perPage === 'number' ? perPage : 10
      };
    }
    case constants.FETCH_ALL_USER_LABS_ERROR:
      return {
        ...state,
        fetchUserDetailLoading: false,
      };
    case constants.SET_EXPANDED_ROW_KEYS:
      return {};
    case constants.FETCH_USER:
      return {
        ...state,
        // departmentLoading: true,
        fetchUserDetailLoading: true,
      };
    case constants.FETCH_USER_SUCCESS:
      return {
        ...state,
        currentUserObj: action.data,
        fetchUserDetailLoading: false,
      };
    case constants.FETCH_USER_ERROR:
      return {
        ...state,
        fetchUserDetailLoading: false,
      };
    case constants.SEND_DETAILS_TO_USER:
      return {
        ...state,
        sendDetailLoading: true,
      };
    case constants.SEND_DETAILS_TO_USER_SUCCESS:
      return {
        ...state,
        sendDetailLoading: false,
      };
    case constants.SEND_DETAILS_TO_USER_ERROR:
      return {
        ...state,
        sendDetailLoading: false,
      };
    case constants.UPDATE_USER_SETTINGS:
      const { data, loadingObj } = action.data;
      const { id, ...res } = data;
      return {
        ...state,
        settingsLoading: true,
        settingsUpdatingKey: { ...state.settingsUpdatingKey, ...res },
        ...loadingObj,
      };
    case constants.UPDATE_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        currentUserObj: { ...state.currentUserObj, ...action.data.data },
        // settingsUpdatingKey: { ...state.settingsUpdatingKey, ...res },
        settingsLoading: false,
        ...action.data.loadingObj,
      };
    case constants.UPDATE_USER_SETTINGS_ERROR:
      return {
        ...state,
        settingsLoading: false,
        currentClientObj: {
          ...state.currentClientObj,
        },
      };
    case constants.USER_DETAIL_CLEANUP_FUNC:
      return {
        ...state,
        allUsers: [],
        createUserLoading: false,
        currentUserObj: {},
        user_labs: [],
        userDetailsIsEdit: false,
        fetchUsersLoading: false,
        deleteUserLoading: false,
        createLabLoading: false,
        currentLabObj: {},
        LabDetailsIsEdit: false,
        fetchLabsLoading: false,
        deleteLabLoading: false,
        departmentLoading: false,
        departmentIsEdit: false,
        departmentsList: [],
        departItemsIndex: null,
        isEditLabPermissions: false,
      };
    default:
      return state;
  }
};

export default userManagerReducer;
